// Public read of the Emergency Contacts phone book from Supabase.
//
// Replaces the Apps Script `?action=emergencycontacts&site=<key>` feed the FOH and
// kitchen tiles used — same PUBLIC exposure (the old feed was an unauthenticated GET),
// just served from Supabase now. Returns the ACTIVE rows for this site: Site 'all'
// fans out to every app, plus rows tagged with this site's key. Archived rows are
// hidden by RLS (see migrations/0014). Writes stay admin-only (Command Centre → admin-data).
//
// Mapped back to the shape the tiles already render: {contactId, site, group, name,
// role, phone, sortOrder}.
import { supabase } from "./supabaseClient.js";

export async function fetchEmergencyContacts(siteKey) {
  const { data, error } = await supabase
    .from("emergency_contacts")
    .select("id,site,category,name,role,phone,sort_order")
    .eq("status", "active")
    .or("site.eq.all,site.eq." + siteKey);
  if (error) throw new Error(error.message || "Failed to load contacts");
  return (data || []).map((r) => ({
    contactId: r.id,
    site: r.site,
    group: r.category,
    name: r.name,
    role: r.role || "",
    phone: r.phone || "",
    sortOrder: r.sort_order || 0,
  }));
}
